import { createContext } from 'react';
import { SECURITY_STATES, CANDIDATE_SECURITY_STATUS } from './constants';
import { defaultClosedBookPolicy } from './securityPolicy';

export const disabledSecureExamValue = {
  enabled: false,
  securityStatus: CANDIDATE_SECURITY_STATUS.SECURE,
  securityState: SECURITY_STATES.EXAM_ACTIVE,
  isFullscreen: false,
  enterFullscreen: async () => {},
  screenShareActive: false,
  screenShareStream: null,
  startScreenShare: async () => {},
  currentRiskScore: 0,
  violationCounts: {
    fullscreenExits: 0,
    tabSwitches: 0,
    focusLosses: 0,
    clipboardAttempts: 0,
    navigationAttempts: 0,
    screenShareStops: 0
  },
  securitySessionId: null,
  canStartExam: true,
  canInteractWithExam: true,
  environmentCheckComplete: true,
  markEnvironmentCheckComplete: () => {},
  logSecurityEvent: async () => {},
  flushSecurityEvents: async () => {},
  finalizeAndSubmit: async () => {},
  pauseTimerOnSecurityInterruption: false,
  policy: defaultClosedBookPolicy,
  overlay: null
};

export const SecureExamContext = createContext(disabledSecureExamValue);
